var React = require('react');

function Icon(props) {
  return React.cloneElement(
    React.createElement(
      'svg',
      { height: '24', width: '24', viewBox: '0 0 24 24' },
      React.createElement('path', {
        d:
          'M5 19H19V7H5V19ZM5 6H19V5H5V6ZM20 3L21 4V20L20 21H4L3 20V4L4 3H20ZM7.47068 16.5649L14.1463 17.9L15.6731 14.6733L16.4 8.165L13.7223 7.9L13.2299 12.3094L12.3902 8.59222L9.75666 9.11903L10.5963 12.8363L6.8 13.5956L7.47068 16.5649ZM11.3331 13.5704C11.3819 13.5697 11.4297 13.5789 11.474 13.5976C11.5646 13.6364 11.7179 13.719 11.7492 13.8449C11.7938 14.026 11.7508 14.1781 11.6128 14.2967C11.4751 14.4153 11.293 14.4043 11.1002 14.344C10.907 14.2837 10.8214 14.0643 10.8945 13.799C10.9488 13.6019 11.205 13.5726 11.3331 13.5704ZM12.8547 13.9726C12.917 13.8982 13.0209 13.8017 13.1408 13.7986C13.3357 13.7937 13.5034 13.8761 13.5983 14.025C13.6932 14.1737 13.6457 14.3375 13.5456 14.5014C13.4454 14.6649 13.1828 14.6865 12.9245 14.5675C12.7504 14.4871 12.7514 14.2829 12.7703 14.1583C12.7808 14.0904 12.8096 14.0264 12.8547 13.9726Z'
      })
    ),
    props
  );
}

module.exports = Icon;
